<!-- used to get the logs of all logIds
In (UI) organisation-> audit trail
-->
<template>
  <v-col class="px-0 py-0">
    <x-org-heading heading="Audit Trail"
      ><template slot="org-page-button">
        <x-button
          v-if="false"
          color="#58e2c2"
          class="w-auto"
          buttonText="Download results"
          :clickFunction="downloadResults"/></template
    ></x-org-heading>

    <AdvanceSearchContainer
      :primaryColor="primaryColor"
      @clearAllData="clearAll"
      @getSearchObject="searchLogs"
      :searchParams="searchParams"
      :parentDataTestId="advanceSearchdataTestId"
    >
      <template slot="advance_search_items">
        <div>
          <!-- Date -->
          <v-row class="mt-0">
            <v-col sm="12" class="py-0">
              <span class="top-label">Date Within</span>
            </v-col>
          </v-row>
          <v-row class="mb-4" no-gutters>
            <v-col
              xs5
              class="py-0 mt-0 positionRelative"
              sm="5"
              :data-test-id="`${advanceSearchdataTestId}__date-range-wrapper`"
            >
              <v-select
                :items="dateRanges"
                solo
                dense
                flat
                v-model="selectedRange"
                item-text="label"
                item-value="id"
                append-icon="keyboard_arrow_down"
                class="cursorPointer"
                filled
                height="52px"
                :attach="
                  `[data-test-id='${advanceSearchdataTestId}__date-range-wrapper']`
                "
              ></v-select>
            </v-col>
            <v-col sm="2" v-show="selectedRange !== 0">
              <p class="andText md4 pa-3 pl-6">of</p>
            </v-col>
            <v-col
              xs5
              class="py-0 mt-0"
              sm="5"
              v-show="selectedRange !== 0"
              no-gutters
            >
              <DatePicker
                :setDate="selectedDate"
                :parentDataTestId="advanceSearchdataTestId"
              />
            </v-col>
          </v-row>
          <!-- End Date -->
          <!-- Start Details -->
          <v-row class="mt-0">
            <v-col sm="12" class="top-label py-0">
              Details
              <small>( you can use * as wildcard )</small>
            </v-col>
          </v-row>
          <v-row class="mb-4">
            <v-col sm="12">
              <v-row no-gutters>
                <v-col
                  sm="2"
                  class="py-0 mt-0 positionRelative"
                  :data-test-id="
                    `${advanceSearchdataTestId}__details-type-select-box`
                  "
                >
                  <v-select
                    :items="containsOptions"
                    solo
                    dense
                    flat
                    v-model="contains"
                    append-icon="keyboard_arrow_down"
                    item-value="id"
                    class="cursorPointer"
                    filled
                    item-text="label"
                    height="56px"
                    :attach="
                      `[data-test-id='${advanceSearchdataTestId}__details-type-select-box']`
                    "
                  ></v-select>
                </v-col>
                <v-col
                  class="py-0 mt-0 pl-6"
                  sm="10"
                  :data-test-id="`${advanceSearchdataTestId}__details-input`"
                >
                  <v-text-field
                    flat
                    filled
                    solo
                    class="full-width"
                    v-model.trim="searchBody"
                    v-on:keyup.enter="
                      addItems(searchBody, detailedItems, contains)
                    "
                  ></v-text-field>
                  <div
                    class="list-container mt-0"
                    v-if="detailedItems.length > 0"
                    :data-test-id="`${dataTestId}__details-input-tag-list`"
                  >
                    <tag
                      v-for="(item, index) in detailedItems"
                      :key="index"
                      :title="item"
                      :text="truncate(item)"
                      data-class="dynamicTagsdark"
                      :showDelete="true"
                      @click="deleteItem(item, detailedItems)"
                      :data-test-id="
                        `${advanceSearchdataTestId}__details-input-tag-list-item-${index +
                          1}`
                      "
                    ></tag>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- End Details -->
          <!-- Start event group and event  -->
          <v-row class="mt-0 pt-2" no-gutters>
            <v-col sm="7" class="top-label py-0">Event group</v-col>
            <v-col sm="5" class="top-label py-0">Event</v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              class="py-0 mt-0 positionRelative"
              sm="5"
              :data-test-id="
                `${advanceSearchdataTestId}__event-group-select-box`
              "
            >
              <v-select
                :items="eventGroups"
                solo
                dense
                flat
                label="Select event group"
                v-model="eventGroup"
                append-icon="keyboard_arrow_down"
                item-value="id"
                class="cursorPointer"
                filled
                item-text="label"
                height="52px"
                @change="filterEvents"
                :attach="
                  `[data-test-id='${advanceSearchdataTestId}__event-group-select-box']`
                "
              ></v-select>
            </v-col>
            <v-col sm="2"></v-col>
            <v-col
              sm="5"
              class="py-0 mt-0 positionRelative"
              :data-test-id="`${advanceSearchdataTestId}__event-select-box`"
            >
              <v-select
                :items="events"
                solo
                dense
                flat
                label="Select event"
                v-model="eventType"
                append-icon="keyboard_arrow_down"
                item-value="id"
                class="cursorPointer"
                filled
                item-text="label"
                height="52px"
                :attach="
                  `[data-test-id='${advanceSearchdataTestId}__event-select-box']`
                "
              ></v-select>
            </v-col>
          </v-row>
          <!-- End event group and event  -->
          <!-- Start username  -->
          <v-row class="mt-2 pt-2" no-gutters>
            <v-col sm="5" class="top-label py-0">Username</v-col>
            <v-col sm="2" class="top-label py-0"></v-col>
            <v-col sm="5" class="top-label py-0">Sources</v-col>
          </v-row>
          <!-- End username  -->
          <!-- Start source  -->
          <v-row class="mb-4" no-gutters>
            <v-col
              class="py-0 mt-0 positionRelative"
              sm="5"
              :data-test-id="`${advanceSearchdataTestId}__user-name-select-box`"
            >
              <v-autocomplete
                v-if="usersList"
                label="Select user"
                solo
                flat
                filled
                height="52px"
                type
                clearable
                v-model="accessibleBy"
                :items="usersList"
                item-text="firstName"
                item-value="id"
                append-icon="keyboard_arrow_down"
                :attach="
                  `[data-test-id='${advanceSearchdataTestId}__user-name-select-box']`
                "
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title>{{
                      data.item.firstName
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      data.item.email[0]
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col sm="2"></v-col>
            <v-col
              class="py-0 mt-0 positionRelative"
              sm="5"
              :data-test-id="`${advanceSearchdataTestId}__source-select-box`"
            >
              <v-select
                :items="sources"
                solo
                label="Select source"
                dense
                flat
                v-model="sourceType"
                append-icon="keyboard_arrow_down"
                item-value="id"
                class="cursorPointer mb-0 "
                filled
                item-text="label"
                height="52px"
                :attach="
                  `[data-test-id='${advanceSearchdataTestId}__source-select-box']`
                "
              ></v-select>
            </v-col>
          </v-row>
        </div>
      </template>
    </AdvanceSearchContainer>
    <x-table
      :columns="columns"
      :showSelectAll="false"
      :sortBy="sortLogs"
      :updateTableSize="updateTableRowCount"
      :loading="loading"
      :tableRows="logList"
      :paginationData="{ pageSize, pageNumber, totalRecords, setPage }"
      :data-test-id="`${dataTestId}__table`"
    >
      <template slot="table_item" slot-scope="props">
        <tr v-for="log in props.tableRows" :key="log.id">
          <td
            class="clickable"
            @click="goToLogDetail(log)"
            :data-test-id="`${dataTestId}__table__log-id-${log.id}`"
          >
            {{ log.id }}
          </td>
          <td>{{ log.source }}</td>
          <td class="wrap-text">{{ log.event }}</td>
          <td class="wrap-text">{{ log.details }}</td>
          <td>{{ log.username }}</td>
          <td>{{ log.date }}</td>
        </tr>
      </template>
    </x-table>
    <x-dialog
      width="100%"
      :dialogTitle="detailsDialogTitle"
      :dialogState="modalState"
      @toggleModal="val => (modalState = val)"
      :hasFixedHeader="true"
    >
      <template slot="dialog_data">
        <x-table
          v-if="modalState"
          :showCurrentShowing="false"
          :showPagination="false"
          :showPageSizeSelector="false"
          :headerFixed="true"
          :columns="columnsD"
          :showSelectAll="false"
          :tableRows="auditTrailDetails"
        >
          <template slot="table_item" slot-scope="props">
            <tr v-for="detail in props.tableRows" :key="detail.id">
              <td>{{ detail.title }}</td>

              <AuditCompareColumn :column="detail.before" />
              <AuditCompareColumn
                :isChanged="detail.isChanged"
                :column="detail.after"
              />
            </tr>
          </template>
        </x-table>
      </template>
    </x-dialog>
  </v-col>
</template>
<script>
import AuditCompareColumn from './AuditCompareColumn';
import DatePicker from '@/components/Common/DatepickerRaw';
import {
  mergeTwoArrayByKey,
  splitCamelCase,
  splitUnderscoreToCaptialise,
  removeHTMLTags
} from '@/helpers/common';
import { parseAuditData, auditTrailMap } from '@/helpers/AuditTrailHelper';
import EventBus from '@/EventBus';
var findIndex = require('lodash.findindex');
import AuditTrailService from '@/services/AuditTrailService';
import UserService from '@/services/UserService';
import AdvanceSearchContainer from '@/components/AdvanceSearch/AdvanceSearchContainer';

import { getTableColumns } from '@/helpers/TableHelpers';
import {
  containsOptions,
  dateRanges
} from '../AdvanceSearch/AdvanceSearchHelpers';
export default {
  components: {
    DatePicker,
    AuditCompareColumn,
    AdvanceSearchContainer
  },
  data() {
    return {
      modalState: false,
      loading: false,
      loaderMessage: 'Perform a search to see results here.',
      logList: [],
      detailsDialogTitle: '',

      // search text results params
      searching: false,
      searchParamsText: '',

      currentSort: {
        sortBy: 'timeStamp',
        sortOrder: 'DESC'
      },
      searchParams: '',
      columns: this.copyArray(getTableColumns('audit')),
      contains: 'MUST',
      containsOptions: this.copyArray(containsOptions),
      containsMap: {
        MUST: [],
        SHOULD: [],
        MUST_NOT: []
      },
      columnsD: [{ label: 'Title' }, { label: 'Before' }, { label: 'After' }],
      auditTrailDetails: null,
      pageNumber: 1,
      pageSize: 20,
      totalRecords: 0,
      formValid: false,
      searchBody: '',
      accessibleBy: '',
      advancedSearch: false,
      selectedRange: 0,
      dateRanges: this.copyArray(dateRanges),
      selectedDate: new Date().toISOString(),
      detailedItems: [],
      sources: [],
      sourceType: 'all',
      usersList: [],
      allEvents: null,
      userIds: [],
      eventGroups: [],
      eventGroup: 'all',
      events: [],
      primaryColor: '#58e2c2',
      eventType: 'all',
      advanceSearchdataTestId: 'audit-trail-advance-search',
      dataTestId: 'audit-trail'
    };
  },
  props: ['title'],
  watch: {
    // whenever this org is updated from left sidebar, reset everything for the new org
    // eslint-disable-next-line
    currentlySelectedOrgId: {
      handler: function() {
        let userAllowed = false;
        if (this.currentlySelectedOrgId === this.orgId) {
          // means self org is selected
          if (this.$can('view', 'audit_trail')) {
            userAllowed = true;
          }
        } else {
          // means child org is selected
          if (this.$can('view', 'child_audit_trail')) {
            userAllowed = true;
          }
        }
        if (!userAllowed) {
          this.$router.push({ name: 'in-progress' });
        }
        this.getUsers();
        this.clearAll();
      },
      immediate: true
    }
  },
  methods: {
    /**
     * emitted from pagination
     * @param {Number} pageNumber
     */
    setPage(pageNumber) {
      this.pageNumber = pageNumber;
      this.searchLogs();
    },
    /**
     * emitted when table display count changes
     * @param {Number} data
     */
    updateTableRowCount(data) {
      this.pageSize = data;
      this.pageNumber = 1;
      this.searchLogs();
    },
    /**
     * get the log details
     * @param {Object} log
     */
    async goToLogDetail(log) {
      let logDetail = await AuditTrailService.getLogDetails(
        this.currentlySelectedOrgId,
        log.id
      );
      let parsed = this.parseResponse(logDetail);
      if (parsed.data) {
        if (auditTrailMap[parsed.logType]?.noPreview) {
          this.snackbar('info', this.$message.NO_PREVIEW);
          return;
        }
        let after;
        let before;

        after = parseAuditData(parsed.data.after, parsed.logType);
        before = parseAuditData(parsed.data.before, parsed.logType);

        const checkRender = after.length ? true : false;
        const mergedBeforeAfter = mergeTwoArrayByKey(
          checkRender
            ? { data: after, key: 'after' }
            : { data: before, key: 'before' },
          checkRender
            ? { data: before, key: 'before' }
            : { data: after, key: 'after' },
          'id'
        );

        this.auditTrailDetails = mergedBeforeAfter;
      } else {
        this.auditTrailDetails = [];
        this.snackbar('info', this.$message.NO_PREVIEW);
        return;
      }
      this.detailsDialogTitle = log.event + ' by ' + log.username;
      this.modalState = true;
      return;
    },
    // to download result data
    downloadResults() {
      return false;
    },
    /**
     * add item tags to search
     * @param {String} item
     * @param {Array} arr
     * @param {String} contains
     */
    addItems(item, arr, contains = null) {
      if (item.trim() === '') {
        return;
      }
      let itemToSearch = item.trim();
      if (contains) {
        let containsItem = this.containsOptions.find(
          item => item.id === contains
        );
        itemToSearch += ` (${containsItem.label})`;
      }
      let index = findIndex(arr, el => {
        return el === itemToSearch;
      });
      if (index === -1) {
        if (contains) {
          this.containsMap[contains].push(item);
          let containsItem = this.containsOptions.find(
            item => item.id === contains
          );
          item += ` (${containsItem.label})`;
        }
        arr.push(item);
      }
      this.searchBody = '';
    },
    /**
     * delete the item tag
     * @param {String} item
     * @param {Array} arr
     */
    deleteItem(item, arr) {
      let index = findIndex(arr, el => {
        return el === item;
      });
      if (index >= 0) {
        arr.splice(index, 1);
      }
      //delete from containsMap
      let containsLabel = [];
      containsLabel['SHOULD'] = 'Should';
      containsLabel['MUST'] = 'Must';
      containsLabel['MUST_NOT'] = 'Must Not';
      for (var key in this.containsMap) {
        if (this.containsMap[key].length) {
          index = findIndex(this.containsMap[key], el => {
            return el + ' (' + containsLabel[key] + ')' === item;
          });
          if (index >= 0) {
            this.containsMap[key].splice(index, 1);
          }
        }
      }
    },
    // filter the event groups
    filterEvents() {
      if (this.eventGroup === 'all') {
        this.events = [
          {
            id: 'all',
            label: 'All'
          }
        ];
        this.eventType = 'all';
        return;
      }
      let events = this.allEvents[this.eventGroup];
      events = events.map(event => {
        return this.formatEntry(event);
      });
      this.events = [
        {
          id: 'all',
          label: 'All'
        },
        ...events
      ];
    },
    // get the search params(more like search filters)
    getSearchParams() {
      let eventType = this.events.find(event => event.id === this.eventType)
        ?.label;
      let eventGroup = this.eventGroups.find(
        eventGroup => eventGroup.id === this.eventGroup
      )?.label;
      let sourceType = this.sources.find(
        source => source.id === this.sourceType
      )?.label;
      if (sourceType === 'All') {
        sourceType = sourceType + '_DEFAULT';
      }
      if (eventGroup === 'All') {
        eventGroup = eventGroup + '_DEFAULT';
      }
      if (eventType === 'All') {
        eventType = eventType + '_DEFAULT';
      }
      return {
        dates: this.getSelectedDates({
          selectedDate: this.selectedDate,
          selectedRange: this.selectedRange
        }),
        sourceType,
        eventGroup,
        eventType,
        accessibleBy: this.getUserName(this.accessibleBy)
          ? [this.getUserName(this.accessibleBy)]
          : [],
        detailedItems: this.detailedItems
      };
    },

    //display search filters
    displaySearchCriteria() {
      this.searchParams = this.getSearchParams();
    },
    // get users list
    async getUsers() {
      try {
        let users = await UserService.loadUsersAll();
        users = this.parseResponse(users);
        if (users !== false) {
          this.usersList = users[0].results;
        } else {
          this.snackbar('error', this.$message.CANT_LOAD_USERS);
        }
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    // get sources list
    async getSources() {
      try {
        let sources = await AuditTrailService.getSources();
        sources = this.parseResponse(sources);
        if (sources !== false) {
          sources = sources.map(source => {
            return this.formatEntry(source);
          });
          sources = [
            {
              id: 'all',
              label: 'All'
            },
            ...sources
          ];
          this.sources = sources;
        } else {
          this.snackbar('error', this.$message.CANT_LOAD_SOURCE);
        }
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    // get event and event groups data
    async getEventAndEventGroups() {
      try {
        let categories = await AuditTrailService.getEventCategories();
        categories = this.parseResponse(categories);
        if (categories !== false) {
          let groups = Object.keys(categories);
          groups = groups.map(group => {
            return this.formatEntry(group);
          });
          this.allEvents = categories;
          this.eventGroups = [
            {
              id: 'all',
              label: 'All'
            },
            ...groups
          ];
          this.filterEvents();
        } else {
          this.snackbar('error', this.$message.CANT_LOAD_EVENTS);
        }
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    /**
     * format the entry label
     * @param {String} entry
     */
    formatEntry(entry) {
      let label = splitCamelCase(
        splitUnderscoreToCaptialise(entry.split('_').join(' '))
      );
      return { id: entry, label: label };
    },
    /**
     * sort table data
     * @param {Object} tableSortData
     */
    sortLogs(tableSortData) {
      this.currentSort.sortBy = tableSortData.sortBy;
      this.currentSort.sortOrder = tableSortData.sortOrder;
      this.searchLogs();
    },
    // clear all the set search params (search filters)
    clearAll() {
      const allItems = this.clearItem({ all: true });
      Object.keys(allItems).forEach(item => {
        this[item] = allItems[item];
      });
      this.searchLogs();
    },
    /**
     * clear each item
     * @param {Boolean} all
     * @param {String} id
     */
    clearItem({ all, id }) {
      const items = {
        pageNumber: 1,
        pageSize: 20,
        totalRecords: 0,
        loading: false,
        loaderMessage: 'Perform a search to see results here.',
        selectedRange: 0,
        selectedDate: new Date().toISOString(),
        eventGroup: 'all',
        eventType: 'all',
        contains: 'MUST',
        accessibleBy: '',
        searchBody: '',
        detailedItems: [],
        containsMap: {
          MUST: [],
          SHOULD: [],
          MUST_NOT: []
        },
        sourceType: 'all',
        searchParams: '',
        searchParamsText: ''
      };
      if (all) {
        return items;
      } else {
        return items[id];
      }
    },
    /**
     * searched log results
     * @param {Object} searchObj
     */
    async searchLogs(searchObj) {
      if (searchObj && !searchObj.quickSearch && this.searchBody) {
        this.addItems(this.searchBody, this.detailedItems, this.contains);
      }
      if (searchObj && searchObj.searchText) {
        this.containsMap['MUST'] = [];
        this.containsMap['SHOULD'] = [];
        this.containsMap['MUST_NOT'] = [];
        this.detailedItems = [];
        this.addItems(searchObj.searchText, this.detailedItems, this.contains);
      }

      if (searchObj && searchObj.removeItem) {
        if (searchObj.removeItem === 'selectedRange') {
          this.selectedDate = this.clearItem({
            id: 'selectedDate'
          });
        }
        this[searchObj.removeItem] = this.clearItem({
          id: searchObj.removeItem
        });
      }
      if (searchObj) {
        this.pageNumber = 1;
      }

      this.logList = [];
      this.loading = true;
      let postBody = this.getPostBody();

      try {
        let response = await AuditTrailService.searchLogs(
          this.currentlySelectedOrgId,
          postBody
        );
        response = this.parseResponse(response);
        if (searchObj) {
          this.displaySearchCriteria();
        }
        if (response) {
          this.totalRecords = response.total;
          let records = response.records;
          if (!records.length) {
            this.snackbar('info', this.$message.NO_SEARCH_RESULTS);
            this.loading = false;
            this.loaderMessage = 'No records matching your search found.';
            return;
          }
          records = records.map(logRow => {
            let objSource = logRow['_source'];

            return {
              id: logRow._id,
              source: this.titleCase(objSource['source']),

              event: splitCamelCase(
                splitUnderscoreToCaptialise(objSource['logType'])
              ),

              details: removeHTMLTags(objSource['summary']),
              username: this.getUserName(objSource['userId']),
              date: this.getFormatedDateAsPerTimeAndDate(objSource['timeStamp'])
            };
          });

          this.addUserDetails([...new Set(this.userIds)]);

          this.logList = records;
          return;
        }

        this.snackbar('error', this.$message.LOG_SEARCH_ERROR);
      } catch (err) {
        console.log(err);
        this.loaderMessage = this.$message.LOG_SEARCH_ERROR;
        this.snackbar('error', this.$message.LOG_SEARCH_ERROR);
        this.loading = false;
        this.totalRecords = 0;
        this.pageSize = 20;
      }
    },
    /**
     * to get username
     * @param {String} userId
     */
    getUserName(userId) {
      let name = 'NA';
      let user = this.usersList.find(user => user.id === userId);

      if (user) {
        name = this.formatUserName(user);
      } else {
        if (userId) {
          this.userIds.push(userId);
        }

        name = this.formatUserName(this.userIdNameMap[userId]);
      }
      return name;
    },
    // get post body to search the logs
    getPostBody() {
      let objRequest = {
        pageNo: this.pageNumber,
        pageSize: this.pageSize
      };
      objRequest['sortBy'] = this.currentSort.sortBy;
      objRequest['desc'] = this.currentSort.sortOrder === 'DESC' ? true : false;

      let selectedDates = this.getSelectedDates({
        selectedDate: this.selectedDate,
        selectedRange: this.selectedRange
      });
      objRequest['fromDate'] = selectedDates['start'];
      objRequest['toDate'] = selectedDates['end'];
      if (this.eventGroup !== 'all') {
        objRequest['category'] = this.eventGroup;
      }
      if (this.eventType !== 'all') {
        objRequest['logType'] = this.eventType;
      }
      if (this.accessibleBy) {
        objRequest['userId'] = this.accessibleBy;
      }
      if (this.sourceType !== 'all') {
        objRequest['source'] = this.sourceType;
      }
      let summary = [];
      if (this.detailedItems.length) {
        Object.keys(this.containsMap).forEach(key => {
          if (this.containsMap[key].length) {
            let obj = {
              containsType: key,
              keywords: this.containsMap[key]
            };
            summary.push(obj);
          }
        });
      }
      objRequest['summary'] = summary;
      return objRequest;
    }
  },
  mounted() {
    // eslint-disable-next-line
    this.columns[5].field = 'timeStamp';
    EventBus.$on('getUpdatedDataOnDateChange', selectedDate => {
      this.selectedDate = selectedDate;
      this.displaySearchCriteria();
    });
  },
  created() {
    // get event groups, events and event sources

    this.getSources();
    this.getEventAndEventGroups();
  }
};
</script>

<style>
.changed {
  background-color: #58e2c2 !important;
}
</style>
